@if (managedHotel?.is_archived) {
  <div class="hc-topbar__archived-banner">
    <lucide-icon name="archive" [size]="16" aria-hidden="true"></lucide-icon>
    <span>{{ 'common.hotel_archived_banner' | translate }}</span>
  </div>
}
<header id="page-topbar">
  <div class="hc-topbar">
    <!-- Hamburger: visible when sidebar is collapsed (desktop) or on mobile -->
    <button type="button" class="hc-topbar__hamburger"
            (click)="toggleMobileMenu($event)"
            [attr.aria-label]="'common.toggle_menu' | translate">
      <lucide-icon name="menu" [size]="20" aria-hidden="true"></lucide-icon>
    </button>

    <!-- Main Container -->
    <div class="hc-topbar__main">
      <!-- Hotel Name -->
      <hc-button variant="link" leftIcon="house" (clicked)="openHotelsDialog()"
                 [ariaLabel]="'common.select_hotel' | translate"
                 class="hc-topbar__hotel-name">
        <span class="hc-topbar__hotel-name-text">{{ managedHotel?.name }}</span>
      </hc-button>

      <!-- Right actions -->
      <div class="hc-topbar__actions">
        <!-- Notifications -->
        <app-notification-bell></app-notification-bell>

        <!-- Share -->
        <hc-button variant="link" leftIcon="share-2" (clicked)="copyShareLink()"
                   [ariaLabel]="'common.share_url' | translate"
                   class="d-none d-lg-inline-flex">
          {{ 'share' | translate }}
        </hc-button>

        <hc-button variant="link" leftIcon="credit-card" (clicked)="openCardValidityDialog()"
                   [ariaLabel]="'dashboard.verify_card.title' | translate"
                   class="d-none d-lg-inline-flex">
          {{ 'dashboard.verify_card.title' | translate }}
        </hc-button>

        <!-- Language Switcher — keeps raw button (flag image doesn't fit leftIcon) -->
        <div class="hc-topbar__dropdown d-none d-lg-inline-flex" ngbDropdown placement="bottom-right">
          <button type="button" class="hc-topbar__link-btn" ngbDropdownToggle>
            @if (flagvalue === undefined) {
              <img [src]="valueset" alt="{{ 'HEADER.HEADER_LANGUAGE' | translate }}" class="hc-topbar__flag-icon">
            } @else {
              <img [src]="flagvalue" alt="{{ 'HEADER.HEADER_LANGUAGE' | translate }}" class="hc-topbar__flag-icon">
            }
            <span class="hc-topbar__link-label">{{ getSelectedLanguageName() }}</span>
          </button>
          <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
            @for (item of listLang; track $index) {
              <a href="javascript:void(0);" class="dropdown-item d-flex align-items-center gap-2"
                 (click)="setLanguage(item.name, item.lang, item.flag)"
                 [ngClass]="{'active': cookieValue === item.lang}">
                <img [src]="item.flag" alt="" height="14">
                <span>{{ item.name }}</span>
              </a>
            }
          </div>
        </div>

        <!-- User Profile — keeps raw button (ngbDropdownToggle needs native element) -->
        <div class="hc-topbar__dropdown d-none d-lg-inline-flex" ngbDropdown>
          <button type="button" class="hc-topbar__user-btn"
                  id="page-header-user-dropdown"
                  ngbDropdownToggle
                  [class.hc-topbar__user-btn--impersonating]="isImpersonating">
            <lucide-icon name="circle-user" [size]="24" aria-hidden="true"></lucide-icon>
            <span class="hc-topbar__user-name">
              @if (isImpersonating) {
                <lucide-icon name="arrow-left-right" [size]="16" class="hc-topbar__impersonation-icon" aria-hidden="true"></lucide-icon>
              }
              {{ getDisplayUserName() }}
            </span>
          </button>
          <div class="dropdown-menu dropdown-menu-end pt-0" ngbDropdownMenu>
            <div class="hc-topbar__user-dropdown-header" [class.hc-topbar__user-dropdown-header--impersonating]="isImpersonating">
              <h6 class="mb-0 text-white">{{ getDisplayUserName() }}</h6>
              <p class="mb-0 text-white-50 fw-semibold hc-topbar__user-role-label">
                {{ isImpersonating ? ('common.viewing_as' | translate) : getUserRoleName() }}
              </p>
            </div>
            <a class="dropdown-item d-flex align-items-center" routerLink="/user-profile">
              <lucide-icon name="circle-user" [size]="16" class="text-muted me-2" aria-hidden="true"></lucide-icon>
              <span>{{ 'profile.my_profile' | translate }}</span>
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item d-flex align-items-center" href="javascript: void(0);" (click)="logout($event)">
              <lucide-icon name="log-out" [size]="16" class="text-muted me-2" aria-hidden="true"></lucide-icon>
              <span>{{ 'common.logout' | translate }}</span>
            </a>
          </div>
        </div>

        <!-- Mobile: User avatar (visible only on mobile) -->
        <div class="hc-topbar__dropdown d-lg-none" ngbDropdown>
          <button type="button" class="hc-topbar__mobile-user-btn"
                  ngbDropdownToggle
                  [class.hc-topbar__mobile-user-btn--impersonating]="isImpersonating">
            <span class="hc-topbar__user-avatar" [ngClass]="'avatar-' + (getDisplayUserName().charAt(0) || 'a').toLowerCase()">
              {{ (getDisplayUserName().charAt(0) || 'U').toUpperCase() }}
            </span>
          </button>
          <div class="dropdown-menu dropdown-menu-end pt-0" ngbDropdownMenu>
            <div class="hc-topbar__user-dropdown-header" [class.hc-topbar__user-dropdown-header--impersonating]="isImpersonating">
              <h6 class="mb-0 text-white">{{ getDisplayUserName() }}</h6>
              <p class="mb-0 text-white-50 fw-semibold hc-topbar__user-role-label">
                {{ isImpersonating ? ('common.viewing_as' | translate) : getUserRoleName() }}
              </p>
            </div>
            <a class="dropdown-item d-flex align-items-center" routerLink="/user-profile">
              <lucide-icon name="circle-user" [size]="16" class="text-muted me-2" aria-hidden="true"></lucide-icon>
              <span>{{ 'profile.my_profile' | translate }}</span>
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item d-flex align-items-center" href="javascript: void(0);" (click)="logout($event)">
              <lucide-icon name="log-out" [size]="16" class="text-muted me-2" aria-hidden="true"></lucide-icon>
              <span>{{ 'common.logout' | translate }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
